import {
  legacy_createStore as createStore,
  compose,
  applyMiddleware
} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import {
  loadTranslations,
  setLocale,
  syncTranslationWithStore
} from 'react-redux-i18n';
import translations from '../i18n';
import moment from 'moment';
import * as Sentry from '@sentry/react';

const composeEnhancers = compose;
const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk), sentryReduxEnhancer)
);

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch(setLocale('fr'));
moment.locale('fr');

export default store;
